import Vue from 'vue'
import AgGridColumnMethodMixins from '@/Mixins/SigmaClientNew/AgGridColumnMethods'
import { CountryTaxCodeResource, AccountsPayableLineResource, JournalEntryLineResource, PettyCashLineResource, AccountsPayableResource, CheckResource, StateResource } from '@sigmacloud/sigma-client/dist/resources'

/*
* AG Grid Column Defs here
*/
export default Vue.extend({
  mixins: [AgGridColumnMethodMixins],

  data () {
    return {
      taxableVendorGroupColumn: {
        headerName: 'Vendor',
        field: 'vendor',
        colId: 'vendor',
        maxWidth: 200,
        minWidth: 100,
        editable: false,
        sortable: true,
        rowGroupIndex: 1,
        hide: true,
        valueGetter: (params) => params.data ? params.data.vendor_name_line : '',
        valueSetter: () => null
      },

      taxableVendorTypeColumn: {
        headerName: 'Entity Type',
        field: 'entity_type',
        colId: 'entity_type',
        maxWidth: 180,
        minWidth: 100,
        editable: false,
        sortable: true,
        valueGetter: (params) => params.data ? params.data.entity_type : '',
        valueSetter: () => null
      },

      amountGroupColumn: {
        headerName: 'Total',
        field: 'amount',
        colId: 'amount',
        maxWidth: 120,
        minWidth: 80,
        editable: false,
        cellClass: 'amount',
        sortable: true,
        aggFunc: 'sum',
        valueFormatter: (params) => this.intlNumberFormatter(params.value || 0),
        valueGetter: (params) => (params.data ? params.data.amount : ''),
        valueSetter: () => null
      },

      taxableTotalColumn: {
        headerName: 'Taxable',
        field: 'taxable',
        colId: 'taxable',
        maxWidth: 100,
        minWidth: 80,
        editable: false,
        cellClass: 'amount',
        sortable: false,
        aggFunc: 'sum',
        valueFormatter: (params) => this.intlNumberFormatter(params.value || 0),
        valueGetter: (params) => params.data && params.data.tax_code ? params.data.amount : 0,
        valueSetter: () => null
      },

      nonTaxableTotalColumn: {
        headerName: 'Non-Tax',
        field: 'nonTaxable',
        colId: 'nonTaxable',
        maxWidth: 100,
        minWidth: 80,
        editable: false,
        cellClass: 'amount',
        sortable: false,
        aggFunc: 'sum',
        valueFormatter: (params) => this.intlNumberFormatter(params.value || 0),
        valueGetter: (params) => params.data && !params.data.tax_code ? params.data.amount : 0,
        valueSetter: () => null
      },

      taxableTaxCodeColumnOld: {
        headerName: 'Tax Code',
        field: 'tax_code',
        colId: 'tax_code',
        maxWidth: 90,
        minWidth: 50,
        editable: true,
        sortable: true,
        valueGetter: (params) => params && params.data ? (params.data.tax_code === '1099-14' ? 'NEC-3' : params.data.tax_code) : ''
        /*
        valueSetter: () => null
        cellEditor: 'agRichSelectCellEditor',
        cellEditorParams: {
          values: [ '', '1099-1', '1099-2', '1099-3', '1099-4', '1099-5', '1099-6', '1099-7', '1099-8', '1099-9', '1099-10', '1099-11', '1099-12' ]
        }
        */
      },

      taxableTaxCodeColumn: {
        headerName: 'Tax Code',
        field: 'tax_code',
        colId: 'tax_code',
        maxWidth: 90,
        minWidth: 50,
        sortable: false,
        menuTabs: ['columnsMenuTab'],
        // eslint-disable-next-line
        // editable: () => (this.$data.scope.readonly ? false : true),
        editable: true,
        cellClass: 'editable',
        valueFormatter: (params) => params && params.data ? (params.data.tax_code === '1099-14' ? 'NEC-3' : params.data.tax_code) : '',
        // Since we are not directly dealing with a resource (using a sigmaQuery data line), have to do some extra work...
        valueSetter: (params) => {
          // Set the data for Ag-Grid
          if (!params.newValue) {
            params.data.tax_code_id = ''
            params.data.tax_code = ''
            params.data.tax_code_name = ''
          } else {
            params.data.tax_code_id = params.newValue.id
            params.data.tax_code = params.newValue.attributes.code
            params.data.tax_code_name = params.newValue.attributes.name
          }

          // Now queue the resource up for saving later
          let resource, metadata, lineId

          // Handle DCs
          if (params.data.meta_data) metadata = JSON.parse(params.data.meta_data)

          if (metadata && metadata.original_line) {
            lineId = params.data.dc_line_id
            resource = JournalEntryLineResource
          } else {
            lineId = params.data.line_id
            switch (params.data.trans_type) {
              case 'AP':
                resource = AccountsPayableLineResource
                break

              case 'JE':
                resource = JournalEntryLineResource
                break

              case 'PC':
                resource = PettyCashLineResource
                break

              case 'CK':
                resource = CheckResource
                break

              default:
                resource = JournalEntryLineResource
            }
          }

          const change = {
            resource,
            id: lineId,
            field: params.colDef.field || 'tax_code',
            newValue: params.data.tax_code_id
          }

          // console.log(change, this.changes)
          if (this.changes) this.changes.push(change)
          return params.newValue
        },
        cellEditor: 'gridAutocomplete',
        cellEditorParams: {
          options: {
            resourceClass: CountryTaxCodeResource
            // updateLineResource: true // this effectively replaces valueSetter.  Needed to handle setting data asynchronously.
          }
        }
      },

      transWorkStateColumn: {
        headerName: 'WkSt',
        field: 'state',
        colId: 'state',
        maxWidth: 70,
        minWidth: 50,
        sortable: false,
        menuTabs: ['columnsMenuTab'],
        editable: (params) => params && params.data && params.data.trans_type === 'AP',
        cellClass: (params) => params && params.data && params.data.trans_type === 'AP' ? 'editable' : '',
        valueFormatter: (params) => params && params.data ? params.data.work_state : '',
        // Since we are not directly dealing with a resource (using a sigmaQuery data line), have to do some extra work...
        valueSetter: (params) => {
          if (params.data.trans_type !== 'AP') {
            return
          }

          // Set the data for Ag-Grid
          if (!params.newValue) {
            params.data.work_state_id = ''
            params.data.work_state = ''
            params.data.work_state_name = ''
          } else {
            params.data.work_state_id = params.newValue.id
            params.data.work_state = params.newValue.attributes.code
            params.data.work_state_name = params.newValue.attributes.name
          }

          // Now queue the resource up for saving later
          let resource = AccountsPayableResource
          let transId = params.data.subledger_id

          const change = {
            resource,
            id: transId,
            field: params.colDef.field || 'state',
            newValue: params.data.work_state_id
          }

          if (this.changes) this.changes.push(change)

          return params.newValue
        },
        cellEditor: 'gridAutocomplete',
        cellEditorParams: {
          options: {
            resourceClass: StateResource
          }
        }
      },

      taxableBoxNECColumn: {
        headerName: 'NEC 1',
        field: 'NEC-1',
        colId: 'NEC-1',
        maxWidth: 100,
        minWidth: 80,
        editable: false,
        cellClass: 'amount',
        sortable: false,
        aggFunc: 'sum',
        valueFormatter: (params) => this.intlNumberFormatter(params.value || 0),
        valueGetter: (params) => params.data && params.data.tax_code === 'NEC-1' ? params.data.amount : 0,
        valueSetter: () => null
      },

      taxableBoxNECGPPColumn: {
        headerName: 'NEC 3',
        field: 'NEC-3',
        colId: 'NEC-3',
        maxWidth: 100,
        minWidth: 60,
        editable: false,
        cellClass: 'amount',
        sortable: false,
        aggFunc: 'sum',
        valueFormatter: (params) => this.intlNumberFormatter(params.value || 0),
        valueGetter: (params) => params.data && params.data.tax_code === '1099-14' ? params.data.amount : 0,
        valueSetter: () => null
      },

      taxableBoxNECWHColumn: {
        headerName: 'NEC 4',
        field: 'NEC-4',
        colId: 'NEC-4',
        maxWidth: 100,
        minWidth: 60,
        editable: false,
        cellClass: 'amount',
        sortable: false,
        aggFunc: 'sum',
        valueFormatter: (params) => this.intlNumberFormatter(params.value || 0),
        valueGetter: (params) => params.data && params.data.tax_code === 'NEC-4' ? params.data.amount : 0,
        valueSetter: () => null
      },

      taxableBoxNECSTWHColumn: {
        headerName: 'NEC 5',
        field: 'NEC-5',
        colId: 'NEC-5',
        maxWidth: 100,
        minWidth: 60,
        editable: false,
        cellClass: 'amount',
        sortable: false,
        aggFunc: 'sum',
        valueFormatter: (params) => this.intlNumberFormatter(params.value || 0),
        valueGetter: (params) => params.data && params.data.tax_code === 'NEC-5' ? params.data.amount : 0,
        valueSetter: () => null
      },

      taxableBoxNEC7Column: {
        headerName: 'NEC 7',
        field: 'NEC-7',
        colId: 'NEC-7',
        maxWidth: 100,
        minWidth: 80,
        editable: false,
        cellClass: 'amount',
        sortable: false,
        aggFunc: 'sum',
        valueFormatter: (params) => this.intlNumberFormatter(params.value || 0),
        valueGetter: (params) => params.data && params.data.work_state && params.data.tax_code === 'NEC-1' ? params.data.amount : 0,
        valueSetter: () => null
      },

      taxableBox1Column: {
        headerName: 'Box 1',
        field: '1099-1',
        colId: '1099-1',
        maxWidth: 100,
        minWidth: 80,
        editable: false,
        cellClass: 'amount',
        sortable: false,
        aggFunc: 'sum',
        valueFormatter: (params) => this.intlNumberFormatter(params.value || 0),
        valueGetter: (params) => params.data && params.data.tax_code === '1099-1' ? params.data.amount : 0,
        valueSetter: () => null
      },

      taxableBox2Column: {
        headerName: 'Box 2',
        field: '1099-2',
        colId: '1099-2',
        maxWidth: 100,
        minWidth: 70,
        editable: false,
        cellClass: 'amount',
        sortable: false,
        aggFunc: 'sum',
        valueFormatter: (params) => params.value ? this.intlNumberFormatter(params.value || 0) : '0.00',
        valueGetter: (params) => params.data && params.data.tax_code === '1099-2' ? params.data.amount : 0,
        valueSetter: () => null
      },

      taxableBox3Column: {
        headerName: 'Box 3',
        field: '1099-3',
        colId: '1099-3',
        maxWidth: 100,
        minWidth: 80,
        editable: false,
        cellClass: 'amount',
        sortable: false,
        aggFunc: 'sum',
        valueFormatter: (params) => this.intlNumberFormatter(params.value || 0),
        // valueGetter: (params) => params.data && params.data.tax_code === '1099-3' ? this.intlNumberFormatter(params.data.amount) : '',
        valueGetter: (params) => params.data && params.data.tax_code === '1099-3' ? params.data.amount : 0,
        valueSetter: () => null
      },

      taxableBox4Column: {
        headerName: 'Box 4',
        field: '1099-4',
        colId: '1099-4',
        maxWidth: 100,
        minWidth: 70,
        editable: false,
        cellClass: 'amount',
        sortable: false,
        aggFunc: 'sum',
        valueFormatter: (params) => this.intlNumberFormatter(params.value || 0),
        valueGetter: (params) => params.data && params.data.tax_code === '1099-4' ? params.data.amount : 0,
        valueSetter: () => null
      },

      taxableBox5Column: {
        headerName: 'Box 5',
        field: '1099-5',
        colId: '1099-5',
        maxWidth: 100,
        minWidth: 40,
        editable: false,
        cellClass: 'amount',
        sortable: false,
        aggFunc: 'sum',
        valueFormatter: (params) => this.intlNumberFormatter(params.value || 0),
        valueGetter: (params) => params.data && params.data.tax_code === '1099-5' ? params.data.amount : 0,
        valueSetter: () => null
      },

      taxableBox6Column: {
        headerName: 'Box 6',
        field: '1099-6',
        colId: '1099-6',
        maxWidth: 100,
        minWidth: 40,
        editable: false,
        cellClass: 'amount',
        sortable: false,
        aggFunc: 'sum',
        valueFormatter: (params) => this.intlNumberFormatter(params.value || 0),
        valueGetter: (params) => params.data && params.data.tax_code === '1099-6' ? params.data.amount : 0,
        valueSetter: () => null
      },

      taxableBox7Column: {
        headerName: 'Box 7',
        field: '1099-7',
        colId: '1099-7',
        maxWidth: 100,
        minWidth: 60,
        editable: false,
        cellClass: (params) => params.value && params.value > 0 ? 'amount error' : 'amount',
        sortable: false,
        aggFunc: 'sum',
        valueFormatter: (params) => this.intlNumberFormatter(params.value || 0),
        valueGetter: (params) => params.data && params.data.tax_code === '1099-7' ? params.data.amount : 0,
        valueSetter: () => null
      },

      taxableBox8Column: {
        headerName: 'Box 8',
        field: '1099-8',
        colId: '1099-8',
        maxWidth: 100,
        minWidth: 40,
        editable: false,
        cellClass: 'amount',
        sortable: false,
        aggFunc: 'sum',
        valueFormatter: (params) => this.intlNumberFormatter(params.value || 0),
        valueGetter: (params) => params.data && params.data.tax_code === '1099-8' ? params.data.amount : 0,
        valueSetter: () => null
      },

      taxableBox9Column: {
        headerName: 'Box 9',
        field: '1099-9',
        colId: '1099-9',
        maxWidth: 100,
        minWidth: 40,
        editable: false,
        cellClass: 'amount',
        sortable: false,
        aggFunc: 'sum',
        valueFormatter: (params) => this.intlNumberFormatter(params.value || 0),
        valueGetter: (params) => params.data && params.data.tax_code === '1099-9' ? params.data.amount : 0,
        valueSetter: () => null
      },

      taxableBox10Column: {
        headerName: 'Box 10',
        field: '1099-10',
        colId: '1099-10',
        maxWidth: 100,
        minWidth: 60,
        editable: false,
        cellClass: 'amount',
        sortable: false,
        aggFunc: 'sum',
        valueFormatter: (params) => this.intlNumberFormatter(params.value || 0),
        valueGetter: (params) => params.data && params.data.tax_code === '1099-10' ? params.data.amount : 0,
        valueSetter: () => null
      },

      taxableBox11Column: {
        headerName: 'Box 11',
        field: '1099-11',
        colId: '1099-11',
        maxWidth: 100,
        minWidth: 40,
        editable: false,
        cellClass: 'amount',
        sortable: false,
        aggFunc: 'sum',
        valueFormatter: (params) => this.intlNumberFormatter(params.value || 0),
        valueGetter: (params) => params.data && params.data.tax_code === '1099-11' ? params.data.amount : 0,
        valueSetter: () => null
      },

      taxableBox12Column: {
        headerName: 'Box 12',
        field: '1099-12',
        colId: '1099-12',
        maxWidth: 100,
        minWidth: 40,
        editable: false,
        cellClass: 'amount',
        sortable: false,
        aggFunc: 'sum',
        valueFormatter: (params) => this.intlNumberFormatter(params.value || 0),
        valueGetter: (params) => params.data && params.data.tax_code === '1099-12' ? params.data.amount : 0,
        valueSetter: () => null
      },
      // No Longer used in 2025-1099
      // taxableBox14Column: {
      //   headerName: 'Box 14',
      //   field: '1099-14',
      //   colId: '1099-14',
      //   maxWidth: 100,
      //   minWidth: 40,
      //   editable: false,
      //   // cellClass: 'amount',
      //   cellClass: (params) => params.value && params.value > 0 ? 'amount error' : 'amount',
      //   sortable: false,
      //   aggFunc: 'sum',
      //   valueFormatter: (params) => this.intlNumberFormatter(params.value || 0),
      //   valueGetter: (params) => params.data && params.data.tax_code === '1099-14' ? params.data.amount : 0,
      //   valueSetter: () => null
      // },

      taxableBox15Column: {
        headerName: 'Box 15',
        field: '1099-15',
        colId: '1099-15',
        maxWidth: 100,
        minWidth: 40,
        editable: false,
        cellClass: 'amount',
        sortable: false,
        aggFunc: 'sum',
        valueFormatter: (params) => this.intlNumberFormatter(params.value || 0),
        valueGetter: (params) => params.data && params.data.tax_code === '1099-15' ? params.data.amount : 0,
        valueSetter: () => null
      },

      taxableBox16Column: {
        headerName: 'Box 16a',
        field: '1099-16a',
        colId: '1099-16a',
        maxWidth: 100,
        minWidth: 40,
        editable: false,
        cellClass: 'amount',
        sortable: false,
        aggFunc: 'sum',
        valueFormatter: (params) => this.intlNumberFormatter(params.value || 0),
        valueGetter: (params) => params.data && params.data.tax_code === '1099-16a' ? params.data.amount : 0,
        valueSetter: () => null
      },

      taxableBox18Column: {
        headerName: 'Box 18',
        field: '1099-18',
        colId: '1099-18',
        maxWidth: 100,
        minWidth: 80,
        editable: false,
        cellClass: 'amount',
        sortable: false,
        aggFunc: 'sum',
        valueFormatter: (params) => this.intlNumberFormatter(params.value || 0),
        valueGetter: (params) => {
          const miscIncomeCodes = [ '1099-1', '1099-2', '1099-3', '1099-5', '1099-6', '1099-8', '1099-9', '1099-10', '1099-11', '1099-12', '1099-14', '1099-15' ]
          return params.data && params.data.work_state && params.data.tax_code && miscIncomeCodes.includes(params.data.tax_code) ? params.data.amount : 0
        },
        valueSetter: () => null
      },

      taxableStateColumn: {
        headerName: 'Wk STs',
        field: 'states',
        colId: 'states',
        maxWidth: 120,
        minWidth: 60,
        editable: false,
        sortable: false,
        aggFunc: 'list',
        // valueFormatter: (params) => this.intlNumberFormatter(params.value || 0),
        valueGetter: (params) => params.data && params.data.work_state || '',
        valueSetter: () => null
      }

      /*
      taxCodeColumn: {
        headerName: 'Tax Code',
        field: 'tax_code',
        colId: 'tax_code',
        maxWidth: 100,
        minWidth: 50,
        editable: false,
        sortable: true,
        valueGetter: (params) => return params && params.data ? params.data.tax_code : '',
        valueSetter: () => null
      }
      */
    }
  }
})



// WEBPACK FOOTER //
// ./src/Mixins/SigmaClientNew/AgGridTaxableLineColumns.js